import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';

export const Checkbox = (props: CheckboxProps) => <MuiCheckbox {...props} />;
